import { ENDPOINT_AIRTABLE_FEEDBACK } from "../../qa-search/constants";
import { RUN_LANGSMITH_URL } from "./../constants/index";
import type { FeedbackParams } from "./../types/index";

export const sendFeedback = async (
	params: FeedbackParams,
	feedback: string,
) => {
	const {
		email,
		type = "Feature",
		appLanguage,
		bundleName,
		currentAppVersion,
		context,
		feature,
		sessionId,
		itemId,
		view,
		platform,
		runId,
		projectId,
		organizationId,
		productId,
		sessionType,
		itemVersionId,
		rating,
	} = params;

	const body = JSON.stringify({
		appVersion: currentAppVersion,
		email,
		feedback,
		appLanguage,
		source: type,
		appContext: context,
		featureName: feature,
		currentUrl: view,
		platform,
		bundleId: productId ? productId.toString() : "N/A",
		bundleName,
		sessionId,
		itemId,
		projectId: projectId ? projectId.toString() : "N/A",
		organizationId: organizationId ? organizationId.toString() : "N/A",
		sessionType,
		itemVersionId,
		...(runId ? { aiRunId: runId } : {}),
		...(runId ? { aiTraceId: RUN_LANGSMITH_URL + runId } : {}),
		...(rating ? { rating } : {}),
	});

	await fetch(ENDPOINT_AIRTABLE_FEEDBACK, {
		method: "POST",
		body,
	});
};
